/**
 * @author      hugo@zumper.com (Hugo Pineda)
 * @copyright   Copyright (c) 2023, Zumper
 */

export const SURVEY_LINK = 'https://zumper2021.typeform.com/to/Db5yKa4y'
